import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Merges class names using clsx and resolves Tailwind CSS conflicts with tailwind-merge.
 *
 * @param inputs - Class values (strings, arrays, objects) to merge.
 * @returns A single, deduplicated className string.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
